/**
 * Button Component - Pulsante standardizzato con varianti
 */

import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  type = 'button',
  onClick,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) => {
  // Varianti di stile
  const variants = {
    primary:
      'bg-gradient-to-r from-anutel to-anutel-dark text-white hover:shadow-lg disabled:opacity-50',
    secondary:
      'bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:opacity-50',
    success:
      'bg-success text-white hover:bg-green-700 disabled:opacity-50',
    danger:
      'bg-error text-white hover:bg-red-700 disabled:opacity-50',
    outline:
      'border-2 border-anutel text-anutel hover:bg-anutel hover:text-white disabled:opacity-50',
    ghost:
      'text-anutel hover:bg-blue-50 disabled:opacity-50',
  };

  // Dimensioni
  const sizes = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg',
  };

  const baseClasses =
    'font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-anutel focus:ring-opacity-50 disabled:cursor-not-allowed';

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
